"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BaseModel_1 = require("./BaseModel");
/** Class representing an user. */
var User = /** @class */function (_super) {
  __extends(User, _super);
  function User(properties) {
    var _this = _super.call(this, {}) || this;
    _this._id = properties._id;
    _this.firstname = properties.firstname;
    _this.lastname = properties.lastname;
    if (properties.email) _this.email = properties.email;
    return _this;
  }
  User.prototype.fullname = function () {
    return [this.firstname, this.lastname].filter(function (s) {
      return !!s;
    }).join(' ');
  };
  return User;
}(BaseModel_1.default);
exports.default = User;